class GroupChildLayout {
  constructor(element) {
    this.element = element;

    this.prevButton = this.findControl('prev');
    this.nextButton = this.findControl('next');

    this.autoplay = element.dataset.groupAutoplay === 'true';
    this.autoplaySpeed =
      parseInt(element.dataset.groupAutoplaySpeed, 10) || 5000;

    this.timer = null;

    this.init();
  }

  findControl(direction) {
    const wrapper = this.element.parentElement;
    if (!wrapper) return null;

    return wrapper.querySelector(
      `.group-layout-arrow--${direction}`
    );
  }

  isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  getCurrentLayout() {
    const desktopLayout =
      this.element.dataset.groupChildLayout || 'default';

    const mobileLayout =
      this.element.dataset.groupMobileLayout || 'same';

    if (this.isMobile()) {
      return mobileLayout === 'same'
        ? desktopLayout
        : mobileLayout;
    }

    return desktopLayout;
  }

  getSlidesPerView() {
    const rootStyle = getComputedStyle(this.element);

    if (this.isMobile()) {
      return (
        parseInt(
          rootStyle.getPropertyValue(
            '--group-carousel-slides-mobile'
          ),
          10
        ) || 1
      );
    }

    if (window.innerWidth < 990) {
      return (
        parseInt(
          rootStyle.getPropertyValue(
            '--group-carousel-slides-tablet'
          ),
          10
        ) || 1
      );
    }

    return (
      parseInt(
        rootStyle.getPropertyValue(
          '--group-carousel-slides-desktop'
        ),
        10
      ) || 1
    );
  }

  getGap() {
    const styles = getComputedStyle(this.element);

    return (
      parseFloat(
        styles.getPropertyValue('--group-layout-gap')
      ) || 0
    );
  }

  getStep() {
    const children = Array.from(this.element.children);

    if (!children.length) return 0;

    const firstChild = children[0];

    const width = firstChild.getBoundingClientRect().width;

    return width + this.getGap();
  }

  scroll(direction) {
    const step =
      this.getStep() * this.getSlidesPerView();

    this.element.scrollBy({
      left: direction * step,
      behavior: 'smooth'
    });
  }

  updateButtons() {
    if (!this.prevButton || !this.nextButton) return;

    const layout = this.getCurrentLayout();

    const isCarousel = layout === 'carousel';

    if (!isCarousel) {
      this.prevButton.style.display = 'none';
      this.nextButton.style.display = 'none';
      return;
    }

    this.prevButton.style.display = '';
    this.nextButton.style.display = '';

    const maxScroll =
      this.element.scrollWidth -
      this.element.clientWidth -
      2;

    this.prevButton.disabled =
      this.element.scrollLeft <= 2;

    this.nextButton.disabled =
      this.element.scrollLeft >= maxScroll;
  }

  startAutoplay() {
    this.stopAutoplay();

    if (!this.autoplay) return;

    if (this.getCurrentLayout() !== 'carousel') return;

    this.timer = setInterval(() => {
      const maxScroll =
        this.element.scrollWidth -
        this.element.clientWidth -
        2;

      if (this.element.scrollLeft >= maxScroll) {
        this.element.scrollTo({
          left: 0,
          behavior: 'smooth'
        });
      } else {
        this.scroll(1);
      }
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  }

  init() {
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => {
        this.scroll(-1);
      });
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => {
        this.scroll(1);
      });
    }

    this.element.addEventListener(
      'scroll',
      () => {
        this.updateButtons();
      },
      { passive: true }
    );

    window.addEventListener('resize', () => {
      this.updateButtons();
      this.startAutoplay();
    });

    this.updateButtons();
    this.startAutoplay();
  }
}

function initGroupChildLayouts(root = document) {
  root
    .querySelectorAll(
      '.group-child-layout'
    )
    .forEach((element) => {
      if (element.dataset.groupLayoutInitialized) return;

      element.dataset.groupLayoutInitialized = 'true';

      new GroupChildLayout(element);
    });
}

document.addEventListener(
  'DOMContentLoaded',
  () => {
    initGroupChildLayouts();
  }
);

document.addEventListener(
  'shopify:section:load',
  (event) => {
    initGroupChildLayouts(event.target);
  }
);

document.addEventListener(
  'shopify:block:select',
  () => {
    initGroupChildLayouts();
  }
);